"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInWithMetamaskButton = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const utils_1 = require("../utils");
const withClerk_1 = require("./withClerk");
exports.SignInWithMetamaskButton = (0, withClerk_1.withClerk)((_a) => {
    var { clerk, children } = _a, props = tslib_1.__rest(_a, ["clerk", "children"]);
    const { redirectUrl } = props, rest = tslib_1.__rest(props, ["redirectUrl"]);
    children = (0, utils_1.normalizeWithDefaultValue)(children, 'Sign in with Metamask');
    const child = (0, utils_1.assertSingleChild)(children)('SignInWithMetamaskButton');
    const clickHandler = async () => {
        async function authenticate() {
            await clerk.authenticateWithMetamask({ redirectUrl });
        }
        void authenticate();
    };
    const wrappedChildClickHandler = async (e) => {
        await (0, utils_1.safeExecute)(child.props.onClick)(e);
        return clickHandler();
    };
    const childProps = Object.assign(Object.assign({}, rest), { onClick: wrappedChildClickHandler });
    return react_1.default.cloneElement(child, childProps);
}, 'SignInWithMetamask');
//# sourceMappingURL=SignInWithMetamaskButton.js.map